import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { AutoTempModes, CoolingModes, TemperatureControlModes, ThermModes } from '@library/store/homes/homes.interface';
import { combineLatest } from 'rxjs';
import { SidebarControlModeService } from '../../sidebar-control-mode.service';

@Component({
  selector: 'app-home-mode-end-date',
  templateUrl: './home-mode-end-date.component.html',
  styleUrls: ['./home-mode-end-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeModeEndDateComponent {

  viewModel$ = combineLatest({
    thermMode: this.controlModeService.thermMode$,
    coolingMode: this.controlModeService.coolingMode$,
    autoTempMode: this.controlModeService.autoTempMode$,
    temperatureControlMode: this.homesFacade.temperatureControlMode$,
    selectedEndDate: this.controlModeService.selectedEndDate$,
    selectedEndTime: this.controlModeService.selectedEndTime$,
  });

  constructor(
    private homesFacade: HomesFacade,
    public controlModeService: SidebarControlModeService,
  ) { }

  displayEndDate(thermMode: ThermModes, coolingMode: CoolingModes, autoTempMode: string, temperatureControlMode: string) {
    if (temperatureControlMode === TemperatureControlModes.HEATING) {
      return thermMode !== ThermModes.SCHEDULE;
    }
    else if (temperatureControlMode === TemperatureControlModes.COOLING) {
      return coolingMode !== CoolingModes.SCHEDULE;
    }
    else if (temperatureControlMode === TemperatureControlModes.AUTO) {
      return autoTempMode !== AutoTempModes.SCHEDULE;
    }
  }

}
